'use strict';

/**
 * Module that checks if the user is on an iOS device and adds a class to the body element.
 * @module iOSDetector
 */
module.exports = function () {
    /**
     * Checks if the current device is running iOS.
     *
     * @returns {boolean} True if the device is an iOS device; otherwise, false.
     */
    function isIOS() {
        return /iPad|iPhone|iPod/.test(navigator.userAgent);
    }

    if (isIOS()) {
        $('body').addClass('is-ios');
    }
};